import axios from '@/libs/api.request'
import qs from 'qs'

// 登陆
export const login = ({ userName, password, verifyId, verifyCode, isAdminLogin }) => {
  let loginUrl = 'login'
  if (isAdminLogin) {
    loginUrl = 'login-admin'
  }
  // 设置参数
  let params = {
    userName,
    password,
    verifyId,
    verifyCode,
    client: 'pc'
  }
  return axios.request({
    method: 'post',
    data: qs.stringify(params),
    url: loginUrl
  })
}

// 重置登录
export const resetLogin = (params) => {
  return axios.request({
    method: 'post',
    data: qs.stringify(params),
    url: 'resetLogin'
  })
}

// 登出
export const logout = (params) => {
  return axios.request({
    method: 'get',
    data: qs.stringify(params),
    url: 'logout'
  })
}

// 获取用户信息
export const getUserInfo = (token) => {
  return axios.request({
    url: 'getUserInfo',
    params: {
      token
    },
    method: 'get'
  })
}

export const check = (params) => {
  return axios.request({
    method: 'post',
    data: qs.stringify(params),
    url: '/core/sys/verify-code/check'
  })
}



// WEBPACK FOOTER //
// ./src/api/login/login-api.js